<template>
  <!-- data-on-dark: der Banner liegt auf bg-surface-xdark. Ohne dieses Attribut
       greifen die on-dark:*-Regeln aus base.css nicht und der Datenschutz-Link
       erbt die dunkle Textvariante der Marke — auf dunklem Grund nur 1,9:1. -->
  <div
    v-if="visible"
    data-on-dark
    class="fixed inset-x-0 bottom-0 z-[90] bg-surface-xdark text-white shadow-2xl"
    role="dialog"
    aria-modal="false"
    aria-labelledby="consent-headline"
    aria-describedby="consent-text"
  >
    <div class="container flex flex-col gap-4 py-5 lg:flex-row lg:items-center lg:justify-between">
      <div class="max-w-3xl">
        <p id="consent-headline" class="mb-1 font-medium">Dürfen wir mitzählen?</p>
        <p id="consent-text" class="text-sm leading-snug">
          Wir messen mit Matomo auf unserem eigenen Server, wie diese Website genutzt wird —
          <strong class="font-medium">ohne Cookies</strong>, mit gekürzter IP-Adresse und ohne Weitergabe an Dritte.
          Die Messung startet nur, wenn Sie zustimmen; ablehnen hat keinerlei Nachteile.
          <a v-if="privacyUrl" :href="privacyUrl" class="underline hover:text-accent-1">{{ privacyLabel }}</a>
        </p>
      </div>
      <!-- Beide Schaltflächen bewusst IDENTISCH gestaltet: gleiche Größe, gleiche
           Farbe, gleiche Position, ein Klick. Eine hervorgehobene "Zustimmen"-
           Taste neben einer blassen "Ablehnen"-Taste wäre ein Dark Pattern und
           macht die Einwilligung nach Art. 7 Abs. 1 DSGVO angreifbar. -->
      <div class="flex shrink-0 flex-col gap-3 sm:flex-row">
        <button type="button" :class="buttonClass" @click="decline">Ablehnen</button>
        <button type="button" :class="buttonClass" @click="accept">Zustimmen</button>
      </div>
    </div>
  </div>
</template>

<script>
// Einwilligungsbanner für die Reichweitenmessung — und NUR dafür.
//
// Bewusst kein "Cookie-Banner": die Seite setzt keine Cookies. Einwilligungs-
// pflichtig ist allein der Zugriff auf das Endgerät durch Matomo (§ 25 TTDSG).
// Externe Einbettungen (YouTube/Vimeo/Maps) haben ihre EIGENE Abfrage direkt am
// Element (VideoConsent.vue) — eine pauschale Zustimmung für beides wäre nicht
// "für den bestimmten Fall" erteilt (Art. 4 Nr. 11 DSGVO).
//
// Ohne konfiguriertes Matomo erscheint der Banner GAR NICHT: dann gibt es
// nichts, wozu eingewilligt werden könnte, und ein Banner wäre irreführend.
import { loadMatomo } from '../matomo.js'
import { dropLegacyConsent, readAnalyticsDecision, writeAnalyticsDecision } from '../consent.js'

export default {
  name: 'AnalyticsConsent',
  props: {
    matomoUrl: {
      type: String,
      default: '',
    },
    matomoSiteId: {
      type: String,
      default: '',
    },
    privacyUrl: {
      type: String,
      default: '',
    },
    privacyLabel: {
      type: String,
      default: 'Mehr in der Datenschutzerklärung.',
    },
  },
  data() {
    return {
      visible: false,
      buttonClass:
        'inline-block w-full border-2 border-white px-6 py-3 text-center font-medium leading-[1.2] text-white transition-colors hover:bg-white hover:text-default sm:w-auto',
    }
  },
  computed: {
    configured() {
      return !!this.matomoUrl && !!this.matomoSiteId
    },
  },
  mounted() {
    dropLegacyConsent()

    if (!this.configured) {
      this.visible = false
      return
    }

    const decision = readAnalyticsDecision()
    // Kein Datensatz oder veraltete Textversion → erneut fragen.
    this.visible = decision === null

    if (decision && decision.status === 'granted') {
      this.startMeasurement()
    }
  },
  methods: {
    startMeasurement() {
      loadMatomo({ url: this.matomoUrl, siteId: this.matomoSiteId })
    },
    accept() {
      writeAnalyticsDecision('granted')
      this.visible = false
      this.startMeasurement()
    },
    decline() {
      // Ablehnung wird ebenfalls festgehalten, sonst fragt der Banner bei jedem
      // Seitenaufruf erneut — das wäre der Klassiker des "Nerv-Patterns".
      writeAnalyticsDecision('denied')
      this.visible = false
    },
  },
}
</script>
